import { useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../env';
import posthog from '../lib/posthog';

export default function Login() {
  const [searchParams] = useSearchParams();
  const handleGoogleLogin = () => {
    const redirect =
      searchParams.get('redirect')
      || `${window.location.origin}/`;
    posthog.capture('login_initiated', { login_provider: 'google' });
    window.location.href = `${API_BASE_URL}/auth/google?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-[var(--sp-4)]"
      style={{ background: 'var(--rd-surface-page)' }}
    >
      <div
        className="w-full max-w-[380px] rounded-[12px] p-[var(--sp-8)] text-center"
        style={{
          background: 'var(--rd-surface-panel)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
        }}
      >
        {/* Logo/brand mark */}
        <div
          className="mx-auto mb-[var(--sp-6)] w-[48px] h-[48px] flex items-center justify-center text-white text-[20px] font-bold"
          style={{ background: 'var(--rd-text-strong)', borderRadius: '12px' }}
        >
          E
        </div>

        <h1
          className="text-[24px] font-bold mb-[var(--sp-1)]"
          style={{ color: 'var(--rd-text-strong)' }}
        >
          Exhibit
        </h1>
        <p
          className="text-[14px] mb-[var(--sp-8)]"
          style={{ color: 'var(--rd-text-subtle)' }}
        >
          Sign in to your workspace
        </p>

        <button
          onClick={handleGoogleLogin}
          className="w-full h-[44px] rounded-[8px] text-[14px] font-semibold cursor-pointer border transition-colors duration-[120ms] flex items-center justify-center gap-[var(--sp-3)]"
          style={{
            background: 'var(--rd-surface-panel)',
            borderColor: 'var(--rd-border)',
            color: 'var(--rd-text-strong)',
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = 'var(--rd-surface-hover)')
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = 'var(--rd-surface-panel)')
          }
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
              fill="#4285F4"
            />
            <path
              d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"
              fill="#34A853"
            />
            <path
              d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
              fill="#FBBC05"
            />
            <path
              d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
              fill="#EA4335"
            />
          </svg>
          Continue with Google
        </button>
      </div>
    </div>
  );
}
